<template>
  <div class="app-container" style="padding:0;">
    <list row-key="UserId" ref="list" unit="合并工单" :page="page" show-query :query-params="params" :get-data-func="api.GetStInProduct" @reset="$refs.picker.clear()" show-checkbox
      @check-change="onCheckChange2">
      <template slot="query">
        <el-form-item el-form-item label="单据日期">
          <range-picker style="width:180px !important;" ref="picker" @change="(x) => {params.DocDateStart=x.Start;params.DocDateEnd=x.End}" />
        </el-form-item>
        <el-form-item label="工单号">
          <el-input style="width:180px;" clearable v-model="params.WorkDocNo" placeholder="请输入工单号" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input style="width:180px;" clearable v-model="params.OrderNo" placeholder="请输入订单号" />
        </el-form-item>
        <el-form-item label="部门" v-if="params.ProductionType===0">
          <el-input style="width:180px;" clearable v-model="params.DpName" placeholder="请输入部门" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocDate" label="单据日期" :formatter="dateFormat" min-width="100" align="left"></el-table-column>
        <el-table-column prop="WorkDocNo" label="工单号" min-width="140" align="left"></el-table-column>
        <el-table-column prop="ProductName" label="存货名称" min-width="180" align="left"></el-table-column>
        <el-table-column prop="MouldName" label="模具名称" min-width="140" align="left"></el-table-column>
        <el-table-column prop="PropertyName" label="属性" min-width="100" align="left">
        </el-table-column>
        <el-table-column prop="ColorName" label="颜色" min-width="100" align="left">
        </el-table-column>
        <el-table-column prop="Quantity" label="工单数" min-width="120" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="UnQuantity" label="待完工数" min-width="120" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.UnQuantity) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="Stage" label="加工阶段" min-width="120" align="left">
          <template slot-scope="{ row }">
            <span v-for="item in processList" v-if="row.Stage === item.ItemValue">{{item.ItemText}}</span>
          </template>
        </el-table-column> -->
        <el-table-column v-if="params.ProductionType===0" prop="DpName" label="部门" min-width="120" align="left"></el-table-column>
        <el-table-column v-if="params.ProductionType===1" prop="TradeUnitName" label="加工商" min-width="120" align="left"></el-table-column>
        <!-- <el-table-column prop="ProgrammeName" label="工艺方案" min-width="120" align="left"></el-table-column> -->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import moment from "moment"

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {
    type: {
      type: Boolean,
      default: true,
    },
    docType: {
      type: Number,
      default: 1
    },
    tableType: {
      type: Number,
      default: 0,
    },
    DictionaryId: {
      type: Number,
      default: 0,
    },
    ProductId: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    processList: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    ProductId(val) {
      this.params.ProductId = val.ProductId
    },
  },
  data() {
    return {
      params: {
        DocDateStart: "",
        DocDateEnd: "",
        ProductId: this.ProductId,
        WorkDocNo: "",
        OrderNo: "",
      },
      data: {},
      commonApi: require("@/api/common/common").default,
      api: require('@/api/production/workDoc').default,
      stInDocApi: require("@/api/stock/stInDoc").default,
      //加工类型
      machiningStageApi: require("@/api/ba/machiningStage").default,
      ProductionPhaseOptions: [],
      selectList: [],
      arr: [],
      routesName: '',
      list: [],
      subList: [],
      tableData: [],
      extraList: [],
      TradeUnitId: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined || date == '') {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    del() { },
    checkChange(list) {
      this.list = list;
    },
    clear() {
      this.list = [];
      this.subList = [];
    },
    onCheckChange(list) {
      this.subList = list;
    },
    onCheckChange2(data,a) {
      console.log("🚀 ~ onCheckChange2 ~ a:", a)
      this.selectList = data;
    },
    onClear() {
      this.selectList = [];
      this.tableData = [];
    }
  },
};
</script>
